var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCourseObjectives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2743 -3343)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2755.5,
    cy: 3355.5,
    r: 12.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2697 -2947)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2715,2953.9l-2.3,0.3l0.3-2.3l-1.7,1.7c-3.3-2.3-7.9-1.4-10.1,1.9s-1.4,7.9,1.9,10.1    s7.9,1.4,10.1-1.9c1.7-2.5,1.7-5.7,0-8.2L2715,2953.9z M2711.5,2963.9c-2.3,2.4-6,2.4-8.4,0.2c-2.4-2.3-2.4-6-0.2-8.4    c0.1-0.1,0.1-0.1,0.2-0.2c2.1-2.1,5.5-2.3,7.9-0.5l-1.6,1.6c-1.7-1.1-3.9-0.7-5.1,1c-1.1,1.7-0.7,3.9,1,5.1c1.7,1.1,3.9,0.7,5.1-1    c0.8-1.2,0.8-2.9,0-4.1l1.6-1.6C2713.8,2958.4,2713.6,2961.8,2711.5,2963.9z M2707,2960c0.3,0.3,0.7,0.3,1,0l1.4-1.4    c0.6,1.1,0.2,2.5-1,3.1c-1.1,0.6-2.5,0.2-3.1-1s-0.2-2.5,1-3.1c0.7-0.3,1.4-0.3,2.1,0l-1.4,1.4    C2706.7,2959.3,2706.7,2959.8,2707,2960z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCourseObjectives);
export default __webpack_public_path__ + "static/media/icon-course-objectives.b412be5da8951453bb5b13b8d415e1cb.svg";
export { ForwardRef as ReactComponent };